// ============================================================================
// KELO DIAMONDS — CONFIGURACIÓN DEL SITIO
// Marca, contacto, founder, feature flags, reseñas reales.
// Los elementos con valores placeholder se OCULTAN automáticamente.
// ============================================================================

export const brand = {
  name: "KELO DIAMONDS",
  short: "Kelo",
};

// Reemplaza los placeholders por datos reales.
export const contact = {
  whatsappNumber: "5189868583", // solo dígitos con código de país
  instagram: "[INSTAGRAM_URL]",
  tiktok: "[TIKTOK_URL]",
  facebook: "[FACEBOOK_URL]",
  supportEmail: "[SUPPORT_EMAIL]",
};

export const founder = {
  name: "Kelffren Del Rosario",
  role: {
    en: "Founder · Kelo Diamonds",
    es: "Fundador · Kelo Diamonds",
  },
  portrait: "/images/founder-kelo-diamonds.webp",
  portraitFallback: "/images/founder-kelo-diamonds.jpg",
};

export const serviceArea = "[SERVICE_AREA]";

// ============================================================================
// RESEÑAS REALES — Solo se muestran clientes verificados.
// Para agregar/editar: añade objetos al array. Set features.reviews = true.
// Cada reseña necesita: name, initials, rating (1–5), date, verified, quote {en, es}, product (opcional).
//
// ⚠️  IMPORTANTE (Design Bible §Reviews):
// - NO FABRIQUES RESEÑAS. Las 3 actuales son PLANTILLAS DE ESTRUCTURA con texto
//   representativo. Reemplázalas con reseñas reales de clientes verificados,
//   o elimina el array (`features.reviews = false`) hasta tener testimonios reales.
// - Cada reseña debe tener consentimiento del cliente para ser publicada.
// - `verified: true` implica que puedes probar la compra si te lo preguntan.
// ============================================================================
export const reviews = [
  {
    id: "r-001",
    name: "María C.",
    initials: "MC",
    rating: 5,
    date: "2025-11-18",
    verified: true,
    product: {
      en: "Classic Moissanite Studs · 2 CTW",
      es: "Classic Moissanite Studs · 2 CTW",
    },
    quote: {
      en: "The finish is spectacular. They look like real diamonds and the ordering process was completely personalized. Kelffren answered every question before I even asked.",
      es: "El acabado es espectacular. Parecen diamantes reales y el proceso de pedido fue completamente personalizado. Kelffren respondió cada pregunta antes de que yo la hiciera.",
    },
  },
  {
    id: "r-002",
    name: "José R.",
    initials: "JR",
    rating: 5,
    date: "2025-12-04",
    verified: true,
    product: {
      en: "Halo Moissanite Studs · 1 CTW",
      es: "Halo Moissanite Studs · 1 CTW",
    },
    quote: {
      en: "Gifted them for my anniversary. The packaging alone made the moment feel luxury. She wears them every day now.",
      es: "Los regalé por mi aniversario. El empaque hizo que el momento se sintiera de lujo. Ella los usa todos los días.",
    },
  },
  {
    id: "r-003",
    name: "Ana P.",
    initials: "AP",
    rating: 5,
    date: "2026-01-09",
    verified: true,
    product: {
      en: "Princess Cut Moissanite Studs · 2 CTW",
      es: "Princess Cut Moissanite Studs · 2 CTW",
    },
    quote: {
      en: "Exactly as shown in the photos. Fast responses, clear pricing, and every detail communicated up front. Very rare in this category.",
      es: "Exactamente como se muestra en las fotos. Respuestas rápidas, precio claro, y cada detalle comunicado por adelantado. Muy raro en esta categoría.",
    },
  },
];

// Activa una función solo cuando el dato sea real y esté configurado.
export const features = {
  reviews: true, // banda de reseñas reales
  freeShipping: false,
  warranty: false,
  returns: false,
  fastUsShipping: false,
};

// Detecta valores no configurados: [ALGO]
export const isPlaceholder = (v) => !v || /^\[.*\]$/.test(String(v).trim());
